import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'
import configurationClient from '@/axiosClients/configurationClient'

export const getPractitionerTitles = async ({ commit }, params = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/practitioner-titles${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextPersonalTypeKey = async ({ commit }) => {
    try {
        const { data: result } = await configurationClient.get(`/catalog/personal-types/next-key`)
        const { data, error } = result.result
        return { data, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, data: null, error: true }
    }
}

export const storePersonalType = async ({ commit }, payload) => {
    try {
        const { data: result } = await configurationClient.post(`/catalog/personal-types/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
